import React from 'react';

import { AuthProvider } from './auth';
import { ModalProvider } from './modal';
import { SidebarProvider } from './sidebar';
import { ToastProvider } from './toast';

const AppProvider: React.FC = ({ children }) => {
  return (
    <ToastProvider>
      <AuthProvider>
        <SidebarProvider>
          <ModalProvider>{children}</ModalProvider>
        </SidebarProvider>
      </AuthProvider>
    </ToastProvider>
  );
};

export { AppProvider };
